import { createContext, useContext } from "react";
import { useState } from "react";
const AuthContext = createContext(null);

export const AuthProvider = ({children}) => {
    const[user,setUser] = useState(null)
    const[isAdmin,setAdmin] = useState(false);

    const login = (user, isAdmin) => {
        setUser(user)
        setAdmin(isAdmin)
    }

    return (
        <AuthContext.Provider value={{user,login,isAdmin}}>
            {children}
        </AuthContext.Provider>
    )
}

export const useAuth = () => {
    return useContext(AuthContext)
} 